/**
 * System config key mapping: API snake_case ↔ UI camelCase.
 */

export const SYSTEM_CONFIG_KEY_MAP = {
  max_recommendations_per_request: 'maxRecommendationsPerRequest',
  indenter_form_enabled: 'indenterFormEnabled',
  vendor_self_registration_enabled: 'vendorSelfRegistrationEnabled',
  vendor_self_registration_disabled_reason: 'vendorSelfRegistrationDisabledReason',
  default_page_size: 'defaultPageSize',
};

export const SYSTEM_CONFIG_UI_TO_API = Object.fromEntries(
  Object.entries(SYSTEM_CONFIG_KEY_MAP).map(([api, ui]) => [ui, api]),
);

function parseConfigValue(row) {
  const raw = row?.value;
  const type = row?.valueType;
  if (type === 'boolean') return raw === 'true' || raw === true;
  if (type === 'integer') {
    const n = parseInt(raw, 10);
    return Number.isNaN(n) ? raw : n;
  }
  return raw ?? '';
}

/** Map API config row list → UI flat config object. */
export function systemConfigFromApiList(rows) {
  const list = Array.isArray(rows) ? rows : [];
  const out = {};
  list.forEach((row) => {
    const uiKey = SYSTEM_CONFIG_KEY_MAP[row.key] || row.key;
    out[uiKey] = parseConfigValue(row);
  });
  return out;
}

export function systemConfigRowFromApi(row) {
  if (!row) return null;
  return {
    id: row.id,
    key: row.key,
    uiKey: SYSTEM_CONFIG_KEY_MAP[row.key] || row.key,
    label: row.label,
    description: row.description,
    group: row.configGroup,
    valueType: row.valueType,
    value: parseConfigValue(row),
    rawValue: row.value,
    defaultValue: row.defaultValue,
    minValue: row.minValue,
    maxValue: row.maxValue,
    isEditable: row.isEditable !== false,
  };
}

/** Serialize a UI value for PUT /system-config/:key */
export function systemConfigValueToApi(uiKey, value) {
  const apiKey = SYSTEM_CONFIG_UI_TO_API[uiKey] || uiKey;
  if (typeof value === 'boolean') return { key: apiKey, value: value ? 'true' : 'false' };
  return { key: apiKey, value: String(value ?? '') };
}
